import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { AdventuresService } from '../adventures.service';
import {EvaluationAdventuresService} from '../evaluation-adventures-serves.service';
import { AdventureItineraryModel } from '../AdventureItineraryModel';
import { AdventureIncludedModel } from '../AdventureIncludedModel';
import { AdventuresModel } from '../AdventuresModel';
import { EvaluationAdventuresModel } from '../EvaluationAdventuresModel';
import { AdventureImagesModel } from '../AdventureImagesModel';
import { ReportService } from '../../Reports/report.service';
import { ReportModel } from '../../Reports/ReportModel';
import { ToastrService } from 'ngx-toastr';
@Component({
    // moduleId: module.id,
    selector: 'adventure-deleails',
    templateUrl: 'adventure-deleails.component.html',
    styleUrls: ['adventure-deleails.component.scss']
})
export class AdventureDeleailsComponent implements OnInit {
    Menuoption = 'center';
    Settingicon = true
      projectDetails : any;
      projectGallaryConfig  = {"slidesToShow": 1,"fade": true, "slidesToScroll": 1,"arrows": false,"dots": false,"autoplay": true, "autoplaySpeed": 2000};
    declare lang: any;
  
      constructor( 
          public router: Router,
          private formBuilder : FormBuilder,
          private modelService :AdventuresService,
          private ReportService:ReportService,
          private EvaluationAdventuresService :EvaluationAdventuresService,
          private toster:ToastrService,
          private route: ActivatedRoute,
          ) {    
              this.Evaluation = [];
              this.id = +route.snapshot.paramMap.get("id");
         }
         id=0;
         ngOnInit() {
          this.lang = localStorage.getItem('theme_lang');
          debugger;
          this.modelService.getAll().subscribe(data=>{
              this.rows=data;
              console.log("modelObject",this.rows)
          })
          if(this.id > 0)
          {
            debugger;
            this.modelService.getById(this.id).subscribe(data=>{
              this.modelObject=data;
              this.files=this.modelObject.adventureImagesList;
              this.includedList=this.modelObject.adventureIncludedList;
              this.itineraryList=this.modelObject.adventureItineraryList;
              this.EvaluationAdventuresService.GetAllByAdventureIdId(this.id).subscribe(data=>{
                this.EvaluationAdventuresList=data;
              })
              console.log("modelObject",this.rows)
  
            })
  
          }
          else{
          }
      }
      selectedIndex: number = 0;
      @Input()
      data:any;
      modelObject: AdventuresModel = new AdventuresModel();
      rows :AdventuresModel[]= [];
      includedList :AdventureIncludedModel[]= [];
      itineraryList :AdventureItineraryModel[]= [];
        EvaluationAdventuresList :EvaluationAdventuresModel[]= [];
      
        EvaluationAdventuresObject: EvaluationAdventuresModel = new EvaluationAdventuresModel();
        EvaluationAdventuresForm: FormGroup = new FormGroup({
        id: new FormControl(),
        comment: new FormControl(),
        AdventureId: new FormControl(),
        numberOfStars: new FormControl(),
        userId: new FormControl(),
        date: new FormControl(),
        time: new FormControl(),
       
    });

    mainForm: FormGroup = new FormGroup({
        id: new FormControl(),
        images: new FormControl(),
        titleAr: new FormControl(),
        titleEn: new FormControl(),
        titleFr: new FormControl(),
        descriptionAr: new FormControl(),
        descriptionEn: new FormControl(),
        descriptionFr: new FormControl(),
        latitude: new FormControl(),
        longitude: new FormControl(),
        countryId: new FormControl(),
        cityId: new FormControl(),
        userId: new FormControl(),
        date: new FormControl(),

    });
   
    public Evaluation:EvaluationAdventuresModel[]=[];
    public myComment: string ='';
    public myStars: number =0;
    public myTime: Date =new Date();
    public myDate: Date =new Date();
    Save() {
        debugger;
        this.EvaluationAdventuresObject = new EvaluationAdventuresModel();
        this.EvaluationAdventuresObject.id = 0;
        this.EvaluationAdventuresObject.comment = this.myComment;
        this.EvaluationAdventuresObject.adventureId = this.id;
        this.EvaluationAdventuresObject.numberOfStars = this.myStars;
        this.EvaluationAdventuresObject.date = this.myDate;
        this.EvaluationAdventuresObject.time = this.myTime;
        this.EvaluationAdventuresObject.userId = 0;
        this.EvaluationAdventuresObject.isHide = false;
        console.log(this.modelObject);
        console.log(this.modelObject);
        this.EvaluationAdventuresService.insert(this.EvaluationAdventuresObject).subscribe((data) => {
          this.myComment='';
          this.myStars=0;
          this.ngOnInit();
          // this.router.navigate(["app/HR/List-Salaries-Manager"]);
        });
      }

      ReportObject:ReportModel=new ReportModel();
      ReportForm:FormGroup=new FormGroup({
      id: new FormControl(),
      message: new FormControl(),
      commentId: new FormControl(),
      userId: new FormControl(),
      type: new FormControl(),
      });
      public message: string ='';
      commetId=0;
      setCommentId(commetId){
        this.commetId =commetId;
  
      }
  @ViewChild('closebutton') closebutton;

        SendReport() {
          debugger;
          this.ReportObject = new ReportModel();
          this.ReportObject.id = 0;
          this.ReportObject.message = this.message;
          this.ReportObject.commentId = this.commetId;
          this.ReportObject.userId = 0;
          this.ReportObject.Type = 'adventure';
          console.log(this.modelObject);
          this.ReportService.insert(this.ReportObject).subscribe((data) => {
            this.message='';
            this.commetId=0;
          this.closebutton.nativeElement.click();
            this.toster.success("Success")
            // this.ngOnInit();
          });
        }

        files:AdventureImagesModel[]=[];
       public picurl: string ='';
       editEnabled = true;
       
     
        CampDetails(id){
          this.router.navigate(['/camps-details/',id]);
          
        }

        customOptions: OwlOptions = {
            // loop: true,
            mouseDrag: true,
            touchDrag: true,
            pullDrag: false,
            // autoplay: true,
            navSpeed: 700,
            navText: ['', ''],
            responsive: {
              0: {
                items: 1
              },
              600: {
                items: 3
              },
              900: {
                items: 4
              }
            },
            nav: false
          };

          customOptions2: OwlOptions = {
            // loop: true,
            mouseDrag: true,
            touchDrag: false,
            pullDrag: false,
            // autoplay: true,
            margin: 15,
            navSpeed: 200,
            navText: ['', ''],
            responsive: {
              0: {
                items: 1
              },
              600: {
                items: 1
              },
              900: {
                items: 3
              }
            },
            nav: false
          };
        
  }
